import { Match } from '@/types'
import { matchesContext } from './MatchesContext'

export const MatchesProvider = ({
  children,
  matches,
  setMatches,
  setOffset,
}: {
  children: React.ReactNode
  matches: Match[]
  setMatches: React.Dispatch<React.SetStateAction<Match[]>>
  setOffset: React.Dispatch<React.SetStateAction<number>>
}) => {
  return <matchesContext.Provider value={{ matches, setMatches, setOffset }}>{children}</matchesContext.Provider>
}
